import englishSvg from '../assets/languages/en.svg'
import spanishSvg from '../assets/languages/es.svg'
import portugueseSvg from '../assets/languages/pt.svg'
import arabicSvg from '../assets/languages/ar.svg'
import chineseSvg from '../assets/languages/zh.svg'
import japaneseSvg from '../assets/languages/ja.svg'
import frenchSvg from '../assets/languages/fr.svg'
import turkishSvg from '../assets/languages/tr.svg'
import polishSvg from '../assets/languages/pl.svg'
import italianSvg from '../assets/languages/it.svg'
// import germanSvg from '../assets/languages/de.svg'
import russianSvg from '../assets/languages/ru.svg'
import dutchSvg from '../assets/languages/nl.svg'
import hebrewSvg from '../assets/languages/he.svg'
import catalaSvg from '../assets/languages/ca.svg'
// import indonesianSvg from '../assets/languages/id.svg'

export const apiTimeout = 20000 // 20 seg
export const headerHeight = 90 // px
export const apiBaseUrl = {
  production: 'https://api.metrica-sports.com/v2/api/',
  development: 'http://api-dev.metrica-sports.com/api/',
  local: 'http://localhost:8082/'
}
export const downloadsAppUrl = {
  production: 'https://downloads.metrica-sports.com',
  development: 'http://downloads-dev.metrica-sports.com',
  local: 'http://localhost:3020'
}
export const cloudAppUrl = {
  production: 'https://cloud.metrica-sports.com/',
  development: 'http://cloud-dev.metrica-sports.com',
  local: 'http://localhost:3018'
}

export const Languages = [
  { value: 'en', label: 'English', icon: englishSvg },
  { value: 'es', label: 'Español', icon: spanishSvg },
  { value: 'pt', label: 'Português', icon: portugueseSvg },
  { value: 'ar', label: 'عربي', icon: arabicSvg },
  { value: 'zh', label: '中文 (简体)', icon: chineseSvg },
  { value: 'ja', label: '日本', icon: japaneseSvg },
  { value: 'fr', label: 'Français', icon: frenchSvg },
  { value: 'tr', label: 'Türkçe', icon: turkishSvg },
  { value: 'pl', label: 'Polski', icon: polishSvg },
  { value: 'it', label: 'Italiano', icon: italianSvg },
  // { value: 'de', label: 'Deutsch', icon: germanSvg },
  { value: 'ru', label: 'Русский', icon: russianSvg },
  { value: 'nl', label: 'Nederlands', icon: dutchSvg },
  { value: 'he', label: 'עִברִית', icon: hebrewSvg },
  { value: 'ca', label: 'Català', icon: catalaSvg }
  // { value: 'id', label: 'Bahasa Indonesia', icon: indonesianSvg }
]

export const theme = {
  palette: {
    common: {
      black: '#000',
      white: '#fff',
      grey: '#929292',
      blue: '#2196f3',
      blue2: '#8fcaf9'
    },
    background: {
      paper: '#eef5f4',
      default: 'rgba(250, 250, 250, 1)'
    },
    primary: {
      light: 'rgba(0, 240, 169, 1)',
      main: '#00c58b',
      dark: 'rgba(22, 172, 128, 1)',
      contrastText: '#fff'
    },
    secondary: {
      light: 'rgba(102, 102, 102, 1)',
      main: 'rgba(68, 68, 68, 1)',
      dark: '#fff',
      contrastText: '#fff'
    },
    error: {
      light: 'rgba(230, 110, 126, 1)',
      main: 'rgba(208, 86, 101, 1)',
      dark: 'rgba(150, 52, 62, 1)',
      contrastText: '#fff'
    },
    text: {
      primary: '#182535',
      secondary: '#182535',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: '#182535'
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: [
      '"Open Sans"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'sans-serif'
    ].join(',')
  }
}

export const AnalyticsEvents = {
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  APP_DOWNLOADED_MAC: 'APP_DOWNLOADED_MAC',
  APP_DOWNLOADED_WIN: 'APP_DOWNLOADED_WIN'
}

// Application product codes as received from the signup form via the URL.
export const Products = {
  PLAY_BASE: 'metrica-play',
  NEXUS: 'metrica-play-3'
}

// URL path slug -> application code.
export const ProductSlugs = {
  playbase: Products.PLAY_BASE,
  nexus: Products.NEXUS
}

// Application code -> product display label.
export const ProductLabels = {
  [Products.PLAY_BASE]: 'PlayBase',
  [Products.NEXUS]: 'Nexus'
}
